import { Injectable } from "@angular/core";
import { Observable } from 'rxjs/Observable';
import { Response } from '@angular/http';
import 'rxjs/add/observable/throw';

import { BaseWebService } from "../../../shared/services/base-web.service";

@Injectable()
export class HeaderNavService {
	constructor(
		private _basewebservice: BaseWebService
	) { }

	/** Service To Fetch notifications**/
	getNotification = () => {
		return this._basewebservice.request("v1/notifications/", "get")
			.map((res: any) => res)
			.catch(this.handleError);
	}

	getPdf(url: any) {
		return this._basewebservice.requestBlobWithResponseHeader(url, 'get')
			.map((res: any) => res)
			.catch(this.handleError);
	}

	getExcel(url:any) {
		return this._basewebservice.request(url, "get")
			.map((res: any) => res)
			.catch(this.handleError);
	}

	markAsRead = (id: any) => {
		return this._basewebservice.request("v1/notification/" + id + "/read/", "get")
			.map((res: any) => res)
			.catch(this.handleError);
	}


	handleError(error: Response | any) {
		return Observable.throw(error);
	}

	catureLogin() {
		return this._basewebservice.request("v1/capture_login_details/", "post")
			.map((res: any) => res)
			.catch(this.handleError);
	}
}